import React, { useState } from "react";
import Navigation from "../components/site/Navigation.jsx";
import Hero from "../components/site/Hero.jsx";
import Diagnostico from "../components/site/Diagnostico.jsx";
import Perfiles from "../components/site/Perfiles.jsx";
import About from "../components/site/About.jsx";
import Historia from "../components/site/Historia.jsx";
import Products from "../components/site/Products.jsx";
import DistribuidoresModal from "../components/site/DistribuidoresModal.jsx";
import RegistroModal from "../components/site/RegistroModal.jsx";
import FloraSection from "../components/site/FloraSection.jsx";
import Contacto from "../components/site/Contacto.jsx";
import Footer from "../components/site/Footer.jsx";
import ProductDetail from "../components/site/ProductDetail.jsx";
import FloraChat from "../components/site/FloraChat.jsx";
import QuoteForm from "../components/site/QuoteForm.jsx";
import { Toaster } from "../components/ui/sonner";
import { useI18n } from "../lib/i18n.jsx";
import { track } from "../lib/analytics.js";

const FLORA_AVATAR = "https://i.imgur.com/cnBBwDr.png";

export default function HomePage() {
  const { t } = useI18n();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteProduct, setQuoteProduct] = useState(null);
  const [chatSeed, setChatSeed] = useState("");
  const [distribModalOpen, setDistribModalOpen] = useState(false);
  const [registroModalOpen, setRegistroModalOpen] = useState(false);

  const openFlora = (seed = "") => {
    track("flora_chat_open", { seed: seed ? "preset" : "blank" });
    setChatSeed(seed);
    setChatOpen(true);
  };
  const openQuote = (product = null) => {
    track("quote_modal_open", { product_id: product?.id || "none" });
    setQuoteProduct(product);
    setQuoteOpen(true);
  };
  const openDistribuye = (source = "nav") => {
    track("distribuye_modal_open", { source });
    setDistribModalOpen(true);
  };
  const openRegistro = (source = "nav") => {
    track("registro_modal_open", { source });
    setRegistroModalOpen(true);
  };
  const scrollToProducts = () => {
    document.getElementById("productos")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App min-h-screen bg-[#f7f7f4]">
      <Navigation
        onOpenFlora={() => openFlora()}
        onOpenQuote={() => openQuote()}
        onOpenDistribuye={() => openDistribuye("nav")}
        onOpenRegistro={() => openRegistro("nav")}
      />
      <main>
        <Hero
          onOpenFlora={() => openFlora()}
          onScrollProducts={scrollToProducts}
          onOpenDistribuye={() => openDistribuye("hero")}
          onOpenRegistro={() => openRegistro("hero")}
        />
        <Diagnostico
          onSelectProduct={setSelectedProduct}
          onRequestQuote={openQuote}
          onAskFlora={(p, sintoma) =>
            openFlora(
              `En mi cultivo observo: ${sintoma}. ¿Es correcto aplicar ${p.name.es}? ¿Qué dosis me recomiendas?`
            )
          }
        />
        <About />
        <Perfiles
          onRequestQuote={() => openQuote()}
          onOpenDistribuye={() => openDistribuye("perfiles")}
          onScrollProducts={scrollToProducts}
        />
        <Historia />
        <Products
          onSelectProduct={setSelectedProduct}
          onRequestQuote={openQuote}
        />
        <FloraSection onOpenFlora={() => openFlora()} />
        <Contacto onOpenQuote={() => openQuote()} />
      </main>
      <Footer
        onOpenQuote={() => openQuote()}
        onOpenDistribuye={() => openDistribuye("footer")}
        onOpenRegistro={() => openRegistro("footer")}
      />

      <ProductDetail
        product={selectedProduct}
        open={!!selectedProduct}
        onClose={() => setSelectedProduct(null)}
        onRequestQuote={(p) => {
          setSelectedProduct(null);
          openQuote(p);
        }}
        onAskFlora={(p) => {
          setSelectedProduct(null);
          openFlora(`Quiero saber más sobre ${p.name.es} para mi cultivo.`);
        }}
      />

      <FloraChat
        open={chatOpen}
        onClose={() => setChatOpen(false)}
        seedMessage={chatSeed}
      />

      <QuoteForm
        open={quoteOpen}
        onClose={() => setQuoteOpen(false)}
        defaultProduct={quoteProduct}
      />

      <DistribuidoresModal open={distribModalOpen} onClose={() => setDistribModalOpen(false)} />
      <RegistroModal open={registroModalOpen} onClose={() => setRegistroModalOpen(false)} />

      {/* Floating Flora chat trigger */}
      {!chatOpen && (
        <button
          onClick={() => openFlora()}
          className="fixed bottom-6 right-6 z-50 group"
          data-testid="flora-chat-trigger"
          aria-label={t.chat.open}
        >
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-[#b45f3e]/30 animate-ping"></div>
            <span className="eu-flora-aura-sm" aria-hidden="true"></span>
            <div className="relative h-16 w-16 rounded-full bg-[#133322] border-2 border-[#9ead9b] overflow-hidden shadow-xl hover:scale-105 transition-transform z-10">
              <img
                src={FLORA_AVATAR}
                alt="Flora"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -top-2 -right-2 bg-[#b45f3e] text-[#f7f7f4] rounded-full h-6 w-6 flex items-center justify-center text-xs z-10">
              <i className="fa-solid fa-comment-dots"></i>
            </div>
          </div>
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#133322] text-[#f7f7f4] text-xs px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition">
            {t.chat.open}
          </span>
        </button>
      )}

      {/* WhatsApp click-to-chat */}
      <a
        href="https://wa.me/34637737339?text=Hola%2C%20me%20gustaría%20más%20información%20sobre%20los%20productos%20Euzerone."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 z-50 h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white flex items-center justify-center shadow-xl hover:scale-105 transition-transform"
        aria-label="WhatsApp"
        data-testid="whatsapp-cta"
      >
        <i className="fa-brands fa-whatsapp text-2xl"></i>
      </a>

      <Toaster richColors position="top-center" />
    </div>
  );
}
